
import { defineComponent, reactive, ref, UnwrapRef, onMounted, toRefs } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import axios from '../../../axios'

export default defineComponent({
    props: {
        id: {
            type: String,
            default: '',
        }
    },
    setup (props) {
        const router = useRouter()
        const route = useRoute()
        const store = useStore()
        const api = process.env.VUE_APP_VENDOR_MASTERLIST_BASEURL
        const isSuccess = ref<boolean>(false)
        const hasError = ref<boolean>(false)

        const form = reactive({
            email: '',
            vendor_name: '',
            vendor_id: '',
            contact_no: '',
            address: '',
            password: '',
            password_confirmation: '',
        });

        const handleFinish = () => {
            store.dispatch('Vendor/register', form)
            .then(() => {
                isSuccess.value = true
                router.push('/login')
            })
        }

        const getVendor = async () => {
            await axios.get(`${api}users/`+ route.query.id).then((res) => {
                const data = res.data.data;
                const { email, vendor_name, vendor_id, contact_no, address } = toRefs(form)
                email.value = data.email;
                vendor_name.value = data.vendor_name;
                vendor_id.value = data.vendor_id;
                contact_no.value = data.contact_no;
                address.value = data.address;
            }).catch((e) => {
                hasError.value = true
            })
        }

        onMounted(() => {
            if(route.query.id){
                getVendor()
            } else {
                router.push('/login')
            }
        })

        return {
            form,
            handleFinish,
            hasError,
            isSuccess,
        }

    },
})
